import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

import css from "./TerAct.module.css";
import { ClinicContext } from "../../Context/ClinicContext";
import { Head } from "../../Utils/Head";
import { updateUserFirebase } from "../../Utils/firebaseUser";
import { UserContext } from "../../Context/UserContext";

export const ListeningPractice = () => {
  const { userData, setUserData } = useContext(UserContext);
  const { step, setStep } = useContext(ClinicContext);
  const [practice, setPractice] = useState("");
  const navigate = useNavigate();
  const stepLength = 3;
  const url = "https://youtu.be/D9gRJv5KbuQ";

  const finish = () => {
    const updatedJourney = {
      level: userData.journey.level,
      lesson: userData.journey.lesson,
      sequence: userData.journey.sequence ? userData.journey.sequence + 1 : 1,
    };

    userData.journey = updatedJourney;
    setUserData(userData);
    updateUserFirebase(userData);
    setStep(0);
    navigate("/");
  };

  return (
    <div className={css.container}>
      <Head
        title="JourneyIntroduction"
        description={"SufferingAxis - Mairini"}
      />
      <section className={css.gridTop}>
        <i
          className={`material-icons ${css.topbarIcon}`}
          onClick={() => {
            setStep(0);
            navigate("/");
          }}
        >
          close
        </i>
        <div className={css.traitBar}>
          <div
            className={css.traitScore}
            style={{
              marginRight: `${((stepLength - step) * 100) / stepLength}%`,
            }}
          ></div>
        </div>
      </section>
      <section className={css.gridMain}>
        {step === 0 && (
          <div>
            <p>Escolha uma prática</p>
            <h1>Prática de ouvir</h1>
            <div className={css.cardContainer}>
              <div
                className={
                  practice ===
                  "https://www.youtube.com/embed/nPruxQl1HFQ?si=WrzdOaUP75CueHTS"
                    ? css.cardActive
                    : css.card
                }
                onClick={() =>
                  setPractice(
                    "https://www.youtube.com/embed/nPruxQl1HFQ?si=WrzdOaUP75CueHTS"
                  )
                }
              >
                <h2>Ouvindo a chuva</h2>
                <p>5 minutos</p>
              </div>
              <div
                className={
                  practice ===
                  "https://www.youtube.com/embed/QzEAssFrqiY?si=WqwcmuXMFtZlUx3M"
                    ? css.cardActive
                    : css.card
                }
                onClick={() =>
                  setPractice(
                    "https://www.youtube.com/embed/QzEAssFrqiY?si=WqwcmuXMFtZlUx3M"
                  )
                }
              >
                <h2>Ouvindo o riacho</h2>
                <p>7 minutos</p>
              </div>
              <div
                className={
                  practice ===
                  "https://www.youtube.com/embed/lmeeVqDjvVw?si=iGKLsS6P2i80Ul7a"
                    ? css.cardActive
                    : css.card
                }
                onClick={() =>
                  setPractice(
                    "https://www.youtube.com/embed/lmeeVqDjvVw?si=iGKLsS6P2i80Ul7a"
                  )
                }
              >
                <h2>Ouvindo a praia</h2>
                <p>15 minutos</p>
              </div>
            </div>
            <h1>Pomodoro</h1>
            <div className={css.cardContainer}>
              <div
                className={
                  practice ===
                  "https://www.youtube.com/embed/gD09uR6ASyQ?si=SsgGxZUGN4J-9w3y"
                    ? css.cardActive
                    : css.card
                }
                onClick={() =>
                  setPractice(
                    "https://www.youtube.com/embed/gD09uR6ASyQ?si=SsgGxZUGN4J-9w3y"
                  )
                }
              >
                <h2>Pomodoro 25/5</h2>
                <p>Chuva</p>
              </div>
            </div>
            <h1>Meditação Guiada</h1>
            <div className={css.cardContainer}>
              <div
                className={
                  practice ===
                  "https://www.youtube.com/embed/sBSNGBIwVLw?si=bFN8N3nT7Viw_G9t"
                    ? css.cardActive
                    : css.card
                }
                onClick={() =>
                  setPractice(
                    "https://www.youtube.com/embed/sBSNGBIwVLw?si=bFN8N3nT7Viw_G9t"
                  )
                }
              >
                <h2>Meditação antes de dormir</h2>
                <p>8:23 minutos</p>
              </div>
              <div
                className={
                  practice ===
                  "https://www.youtube.com/embed/D9gRJv5KbuQ?si=PWcjNOO7sGdYCq50"
                    ? css.cardActive
                    : css.card
                }
                onClick={() =>
                  setPractice(
                    "https://www.youtube.com/embed/D9gRJv5KbuQ?si=PWcjNOO7sGdYCq50"
                  )
                }
              >
                <h2>Meditação para o trabalho</h2>
                <p>6:47 minutos</p>
              </div>
            </div>
          </div>
        )}
        {step === 1 && (
          <div>
            <h4>Orientações para aproveitar melhor a prática</h4>
            <p>
              A prática guiada é um convite para estar presente com o que quer
              que surja — pensamentos, emoções, sensações — sem tentar controlar
              ou evitar a experiência. Abaixo, algumas dicas para te apoiar
              nessa prática:
            </p>
            <h4>1. Não tente “fazer certo”</h4>
            <p>
              A mente vai se distrair, e isso é natural. Quando perceber que se
              perdeu em pensamentos, apenas reconheça isso com gentileza e volte
              sua atenção para a voz, a respiração ou o corpo. Cada vez que você
              retorna, está fortalecendo a habilidade de se reconectar com o
              momento presente.
            </p>
            <h4>2. Dê espaço para o desconforto</h4>
            <p>
              Nem toda prática terapêutica vai ser relaxante — e tudo bem. Se
              surgirem emoções difíceis, observe-as com curiosidade, como se
              estivesse abrindo espaço para que elas estejam ali, sem lutar
              contra. Isso é parte do processo de aceitação.
            </p>
            <h4>3. Observe os pensamentos, não entre na conversa</h4>
            <p>
              Pensamentos virão. Em vez de se envolver com eles, experimente
              apenas notá-los — como se fossem nuvens passando no céu ou carros
              passando por uma rua. Você pode ouvi-los sem precisar acreditar em
              tudo o que dizem.
            </p>
            <h4>4. Traga uma postura de abertura e compaixão</h4>
            <p>
              Você não precisa se esforçar para “esvaziar a mente” ou se sentir
              de um certo jeito. O convite é estar com você mesmo, do jeito que
              estiver, com gentileza e curiosidade. Essa prática não busca se
              livrar do que você sente, mas se aproximar com cuidado.
            </p>
            <h4>5. Relembre o porquê você está praticando</h4>
            <p>
              Talvez você queira cuidar melhor de si, lidar com a ansiedade,
              cultivar mais presença ou viver com mais leveza. Mantenha esses
              valores em mente — eles podem te ajudar a persistir mesmo nos dias
              em que for mais difícil.
            </p>
            <h4>6. Dê tempo para a prática se revelar</h4>
            <p>
              Os efeitos da prática costumam aparecer aos poucos, como o
              crescimento de uma planta. Vá com paciência, constância e sem
              pressa. Mesmo alguns minutos por dia já fazem diferença.
            </p>
          </div>
        )}
        {step === 2 && (
          <div className={css.gridMainContainer}>
            <iframe
              // width="560"
              // height="315"
              src={practice}
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>
          </div>
        )}
        {step === 3 && (
          <div className={css.gridMainContainer}>
            <h1>👏 Parabéns! Você completou a prática.</h1>
          </div>
        )}
      </section>
      <div>
        <section className={css.gridOptions}>
          {step > 0 ? (
            <button
              className={`greenButton ${css.button}`}
              onClick={() => {
                setStep(step - 1);
              }}
            >
              Anterior
            </button>
          ) : (
            <button className={`greenButton ${css.buttonDisabled}`}>
              Anterior
            </button>
          )}
          {step === 0 && !practice ? (
            <button
              className={`greenButton ${css.buttonDisabled}`}
              onClick={() => {
                setStep(step + 1);
              }}
            >
              Próximo
            </button>
          ) : step === stepLength ? (
            <button
              className={`greenButton ${css.button}`}
              onClick={() => {
                finish();
              }}
            >
              Finalizar
            </button>
          ) : (
            <button
              className={`greenButton ${css.button}`}
              onClick={() => {
                setStep(step + 1);
              }}
            >
              Próximo
            </button>
          )}
        </section>
      </div>
    </div>
  );
};
